export default "__VITE_ASSET__PA80aQG8__"